import { render } from "./StatisticsMain.vue?vue&type=template&id=1054a278&scoped=true"
import script from "./StatisticsMain.vue?vue&type=script&lang=js"
export * from "./StatisticsMain.vue?vue&type=script&lang=js"

import "./StatisticsMain.vue?vue&type=style&index=0&id=1054a278&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1054a278"]])

export default __exports__